/* eslint-disable import/order */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable max-len */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable object-property-newline */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react-native/no-inline-styles */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// @ts-ignore
import { jitsiLocalStorage } from 'lib-js-utils';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
// @ts-ignore
// eslint-disable-next-line import/order
import { axiosInstance } from '../../../../../../service/axiosConfig';
// @ts-ignore
import { createInviteDialogEvent, createToolbarEvent, sendAnalytics } from '../../../../analytics';
// @ts-ignore
import { hideDialog } from '../../../../base/dialog';
import { IconCloseModal, IconConnect, IconRemoveKeyboard } from '../../../../base/icons/svg';
import { withPixelLineHeight } from '../../../../base/styles/functions.web';
// @ts-ignore
import { NOTIFICATION_TIMEOUT, showNotification } from '../../../../notifications';
import { invite } from '../../../actions.any';
import { getInviteTypeCounts } from '../../../functions';
import { useInvitePhoneCallKeyBoard } from "./hooks/useInvitePhoneCallKeyBoard";
// eslint-disable-next-line require-jsdoc
function formatPhoneNumber(phoneNumber) {
    return phoneNumber.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
}
const useStyles = makeStyles()(theme => {
    return {
        copyButton: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.bodyShortBold)), { borderRadius: theme.shape.borderRadius, display: 'flex', gap: 12, justifyContent: 'flex-start', alignItems: 'center', padding: `${theme.spacing(2)} ${theme.spacing(3)}`, width: 'max-content', boxSizing: 'border-box', 
            // @ts-ignore
            background: theme.palette.action01, cursor: 'pointer', 
            // @ts-ignore
            color: theme.palette.text01, '&:hover': {
                // @ts-ignore
                backgroundColor: theme.palette.action01Hover
            }, '& > div > svg': {
                // @ts-ignore
                fill: theme.palette.icon01
            } }),
        modal: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            zIndex: 9999,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center'
        },
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            padding: 25,
            borderRadius: 50,
            background: 'rgb(102, 136, 167)',
            marginTop: 64,
            flexDirection: 'column',
            position: 'relative',
        },
        closeIcon: {
            display: 'flex',
            width: '100%',
            justifyContent: 'end',
            marginTop: -20,
            marginLeft: 15,
            cursor: 'pointer',
            position: 'absolute',
            top: 60,
            right: 40,
        },
        content: {
            backgroundColor: '#ffffff',
            borderRadius: 25,
            padding: 36,
            width: 430,
            overflow: 'hidden'
        },
        rowKey: {
            display: 'flex',
            alignItems: 'center',
            gap: 24,
            margin: 'auto',
            width: 'max-content'
        },
        viewKey: {
            padding: 16,
            background: 'rgb(102, 136, 167)',
            borderRadius: 50,
            width: 45,
            height: 45,
            color: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 10,
            cursor: 'pointer'
        },
        keyNumber: {
            fontWeight: 'bold',
            fontSize: '24px',
            textAlign: 'center'
        },
        keyText: {
            textAlign: 'center',
            fontSize: '12px',
            letterSpacing: '1.5px'
        },
        phone: {
            fontSize: 43,
            color: 'black',
            fontWeight: 'bold',
            marginBottom: 40,
            border: 'none',
            background: 'none',
            outline: 'none',
            textAlign: 'center',
            width: '100%',
            '&::placeholder': {
                color: 'black'
            }
        },
        phoneNumber: {
            backgroundColor: 'rgb(27, 84, 135)',
            padding: '20px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            fontSize: 22,
            color: 'white',
            // textTransform: 'uppercase',
            width: 'calc(100% + 40px)',
            marginLeft: -36,
            marginBottom: -36,
            marginTop: 25
        }
    };
});
/**
 * Component meant to enable users to copy the conference URL.
 *
 * @returns {React$Element<any>}
 */
function InviteViaPhoneCall({ room }) {
    var _a, _b, _c;
    const { t } = useTranslation();
    const { classes } = useStyles();
    const dispatch = useDispatch();
    const [openPhone, setOpenPhone] = useState(false);
    const { phone, setPhone, callRef } = useInvitePhoneCallKeyBoard(openPhone);
    const refModal = useRef(null);
    const refClickOpen = useRef(null);
    const [config, setConfig] = useState({
        codec_ip: "",
        codec_name: "",
        dtmfPiN: "",
        enableDtmfPIN: false,
        enableAutoAnswering: false,
        enableAutoGaglCreation: false,
        enableHotlineCalling: false,
        newDids: []
    });
    // @ts-ignore
    const settings = APP.store.getState()['features/base/settings'];
    // v1.0 Release 2: with one shard and one PBX, the dial-in number is always the
    // account's primary Hotline number.
    // @ts-ignore
    // const { conference } = APP.store.getState()['features/base/conference'];
    useEffect(() => {
        var _a;
        // @ts-ignore
        if ((_a = settings.user) === null || _a === void 0 ? void 0 : _a.workspaceId) {
            // @ts-ignore
            axiosInstance.get('/workspaces/configuration').then(({ data }) => {
                console.log({ data });
                setConfig(data.configuration);
            });
        }
        // @ts-ignore
    }, [(_a = settings.user) === null || _a === void 0 ? void 0 : _a.workspaceId]);
    const clickOutSide = useCallback((e) => {
        var _a;
        if ((_a = refModal.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
            return;
        }
        setOpenPhone(false);
    }, []);
    const onChangePhone = useCallback((phoneStr) => {
        if (phone.length >= 11) {
            return;
        }
        setPhone(phone + phoneStr);
    }, [phone]);
    const removePhone = useCallback(() => {
        setPhone(pre => pre.substring(0, pre.length - 1));
    }, []);
    const onCall = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        // conference.dial(phone).then(() => {
        //     invitesLeftToSend = invitesLeftToSend.filter(
        //         invitee => invitee !== item
        //     );
        // })
        // .catch((error: Error) =>
        //     logger.error('Error inviting phone number:', error)
        // );
        console.log('enter open connect');
        sendAnalytics(createToolbarEvent('call phone number'));
        try {
            const invitees = [
                {
                    allowed: true,
                    country: '',
                    number: phone,
                    originalEntry: phone,
                    showCountryCodeReminder: false,
                    type: 'phone',
                    codecName: phone,
                    roomCode: room,
                    name: phone
                }
            ];
            // @ts-ignore
            const jitsiInvitees = {
                filterValues: [`${phone}`, `${phone}`],
                content: `${phone}`,
                description: '',
                isDisabled: false,
                address: '',
                item: invitees[0],
                value: `${phone}`
            };
            jitsiLocalStorage.setItem('inviteItems', JSON.stringify(jitsiInvitees));
            dispatch(invite(invitees, false, (invitesLeftToSend) => {
                var _a;
                setOpenPhone(false);
                dispatch(hideDialog());
                if (invitesLeftToSend.length) {
                    const erroredInviteTypeCounts = getInviteTypeCounts(invitesLeftToSend);
                    sendAnalytics(createInviteDialogEvent('error', 'invite', Object.assign({}, erroredInviteTypeCounts)));
                }
                else {
                    dispatch(showNotification({
                        titleArguments: {
                            name: (_a = invitees[0]) === null || _a === void 0 ? void 0 : _a.name
                        },
                        titleKey: 'notify.invitedOneMember'
                    }, NOTIFICATION_TIMEOUT));
                }
            }));
        }
        catch (e) {
            console.log('error', e);
        }
    }), [phone, room]);
    if (!(config === null || config === void 0 ? void 0 : config.enableHotlineCalling)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { color: 'white' } }, t('addPeople.inviteCall')),
        React.createElement("div", { className: classes.copyButton, onClick: () => setOpenPhone(true), ref: refClickOpen, role: 'button', tabIndex: 0 },
            React.createElement(IconConnect, { style: { width: 20, height: 24 } }),
            "Call Participant"),
        React.createElement("div", { className: classes.modal, onClick: clickOutSide, style: { display: openPhone ? '' : 'none' } },
            React.createElement("div", { className: classes.container },
                React.createElement("div", { className: classes.closeIcon, onClick: () => setOpenPhone(true) },
                    React.createElement(IconCloseModal, { style: { width: 30, height: 30 } })),
                React.createElement("div", { className: classes.content, ref: refModal },
                    React.createElement("div", { className: classes.rowKey },
                        React.createElement("input", { className: classes.phone, placeholder: '(XXX) XXX-XXXX', readOnly: true, style: { color: 'black', marginTop: 15, marginLeft: -50 }, value: formatPhoneNumber(phone) })),
                    React.createElement("div", { className: classes.rowKey },
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('1') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "1"),
                                React.createElement("div", { className: classes.keyNumber, style: { opacity: 0 } }, "ABC"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('2') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "2"),
                                React.createElement("div", { className: classes.keyText }, "ABC"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('3') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "3"),
                                React.createElement("div", { className: classes.keyText }, "DEF")))),
                    React.createElement("div", { className: classes.rowKey },
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('4') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "4"),
                                React.createElement("div", { className: classes.keyText }, "GHI"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('5') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "5"),
                                React.createElement("div", { className: classes.keyText }, "JKL"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('6') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "6"),
                                React.createElement("div", { className: classes.keyText }, "MNO")))),
                    React.createElement("div", { className: classes.rowKey },
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('7') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "7"),
                                React.createElement("div", { className: classes.keyText }, "PQRS"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('8') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "8"),
                                React.createElement("div", { className: classes.keyText }, "TUV"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('9') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "9"),
                                React.createElement("div", { className: classes.keyText }, "WXYZ")))),
                    React.createElement("div", { className: classes.rowKey },
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('*') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber, style: { marginTop: 10, fontSize: 32 } }, "*"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('0') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber }, "0"),
                                React.createElement("div", { className: classes.keyText }, "+"))),
                        React.createElement("div", { className: classes.viewKey, onClick: () => onChangePhone('#') },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber, style: { fontSize: 32 } }, "#")))),
                    React.createElement("div", { className: classes.rowKey, style: { marginTop: 16 } },
                        React.createElement("div", { className: classes.viewKey, style: { background: 'transparent' } }),
                        React.createElement("div", { className: classes.viewKey, style: { background: '#1aa259' } },
                            React.createElement("div", null,
                                React.createElement("div", { ref: callRef, className: classes.keyNumber, onClick: onCall },
                                    React.createElement(IconConnect, { style: { width: 30, height: 30 } })))),
                        React.createElement("div", { className: classes.viewKey, onClick: removePhone, style: { background: 'transparent' } },
                            React.createElement("div", null,
                                React.createElement("div", { className: classes.keyNumber },
                                    React.createElement(IconRemoveKeyboard, { style: { width: 40, height: 40 } }))))),
                    React.createElement("div", { className: classes.phoneNumber },
                        React.createElement("div", null,
                            React.createElement("span", { className: 'info-label' }, t('info.dialInNumber')), (_c = (_b = config === null || config === void 0 ? void 0 : config.newDids) === null || _b === void 0 ? void 0 : _b[0]) !== null && _c !== void 0 ? _c : "Not Available"),
                        (config === null || config === void 0 ? void 0 : config.enableDtmfPIN) && (React.createElement("div", null,
                            React.createElement("span", { className: 'info-label' }, t('info.dialInConferenceID')),
                            (config === null || config === void 0 ? void 0 : config.enableDtmfPIN) ? config === null || config === void 0 ? void 0 : config.dtmfPiN : "N/A"))))))));
}
export default InviteViaPhoneCall;
